import {InternalUser} from '@amplify/athena-models';
import {
    Button,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    makeStyles,
} from '@material-ui/core';
import {toJS} from 'mobx';
import {observer} from 'mobx-react-lite';
import {useEffect, useState} from 'react';
import RootStore from '../Core/mobx/RootStore';
import {CreateAgentPanel} from './AddAgent';
import {OneInternalUser} from './OneInternalUser';

const useStyles = makeStyles(() => ({
    customerTable: {
        fontFamily: 'FredokaRegular',
    },
    tableHeaderRow: {
        '& .MuiTableCell-root': {
            fontWeight: 'bold',
        },
    },
    pageLabel: {
        paddingLeft: '4pt',
        color: '#626EA7',
        fontFamily: 'LoraSemiBold',
        fontSize: '32px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '120%' /* 38.4px */,
    },
}));

export const AgentList = observer(({}) => {
    const userAdminStore = RootStore.userAdminStore;
    const internalUsers = userAdminStore.internalUsers;
    const classes = useStyles();

    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [openCreateInternalUser, setCreateInternalUserModal] = useState(false);
    console.log({internalUsers: toJS(internalUsers)});

    const getInternalUsers = async () => {
        console.log('Getting internal users');
        userAdminStore.getInternalUsers();
    };

    useEffect(() => {
        getInternalUsers();
    }, []);

    async function handleUpdateUser(user: InternalUser) {
        try {
            setIsUpdateLoading(true);
            await userAdminStore.updateInternalUser(user);
        } catch (error: any) {
            RootStore.uiStore.showSnackbar(error.message || 'Failed to update user.', 'error');
        } finally {
            setIsUpdateLoading(false);
        }
    }

    async function handleDeleteUser(email: string) {
        try {
            setIsDeleteLoading(true);
            await userAdminStore.deleteInternalUser(email);
        } catch (error: any) {
            RootStore.uiStore.showSnackbar(error.message || 'Failed to delete user.', 'error');
        } finally {
            setIsDeleteLoading(false);
        }
    }

    return (
        <Grid container justify={'center'} alignItems={'center'}>
            <div style={{width: '100%'}}>
                <Grid
                    container
                    className={classes.customerTable}
                    spacing={3}
                    style={{width: '100%', justifyContent: 'space-between', alignItems: 'center'}}
                >
                    <Grid item xs={3}>
                        <Typography variant="h6" classes={{root: classes.pageLabel}}>
                            Internal User Admin
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setCreateInternalUserModal(true);
                            }}
                        >
                            Add Internal User
                        </Button>

                        <CreateAgentPanel
                            open={openCreateInternalUser}
                            close={() => {
                                setCreateInternalUserModal(false);
                            }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        {internalUsers?.length ? (
                            <TableContainer className="contacts-list" component={Paper}>
                                <Table style={{minWidth: '100%'}} data-testid="contact-list">
                                    <TableHead>
                                        <TableRow classes={{root: classes.tableHeaderRow}}>
                                            <TableCell style={{width: '300px'}}>Email</TableCell>
                                            <TableCell>Roles</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {internalUsers?.map((internalUser) => (
                                            <OneInternalUser
                                                key={internalUser.email}
                                                internalUser={internalUser}
                                                isDeleteLoading={isDeleteLoading}
                                                isUpdateLoading={isUpdateLoading}
                                                onDeleteClick={handleDeleteUser}
                                                onUpdateClick={handleUpdateUser}
                                            />
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <Grid container spacing={3} style={{marginTop: 30, width: '100%'}}>
                                <Grid item xs={12} style={{textAlign: 'center'}}>
                                    {internalUsers === null ? (
                                        <div>please wait... loading...</div>
                                    ) : (
                                        <div>no contact found</div>
                                    )}
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </div>
        </Grid>
    );
});
